// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"426":"d0e5cef3","644":"e8a7b7d3"}[chunkId] + ".chunk.css";
};